const styles = `:host {
  display: inline-flex;
  outline: none;
}
:host .control {
  border-width: 1px;
  border-style: solid;
  cursor: pointer;
  box-sizing: border-box;
  outline: none;
  border-radius: var(--goto-radius-small);
  white-space: normal;
  color: var(--goto-type-color-brand-default, var(--goto-type-color-brand-default));
  border-color: transparent;
  background-color: transparent;
  --goto-icon-size: 1rem;
  --goto-icon-color: var(--goto-icon-color-brand-default);
  padding: 0px 2px;
  margin: 0px -2px;
  text-decoration: var(--goto-link-text-decoration, none);
}
:host .control :hover {
  text-decoration: underline;
}
:host .control:focus-visible {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-interactive-color-secondary-pressed);
}
:host .control:-moz-focusring {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-interactive-color-secondary-pressed);
}
:host ::slotted(chameleon-svg) {
  display: inline-flex;
}

:host([variant=body-small]) {
  font: var(--goto-body-small);
}

:host([variant=body-medium]) {
  --goto-icon-size: 1.125rem;
  font: var(--goto-body-medium);
}

:host([variant=body-large]) {
  --goto-icon-size: 1.25rem;
  font: var(--goto-body-large);
}

:host([variant=caption-medium]) {
  font: var(--goto-caption-medium);
}

:host([variant=caption-medium-strong]) {
  font: var(--goto-caption-medium-strong);
}

:host([variant=caption-small]) {
  font: var(--goto-caption-small);
}

:host([variant=caption-small-strong]) {
  font: var(--goto-caption-small-strong);
}

:host([appearance=primary]),
:host([appearance=secondary]),
:host([appearance=tertiary]) {
  display: inline-flex;
  outline: none;
}
:host([appearance=primary]) .control,
:host([appearance=secondary]) .control,
:host([appearance=tertiary]) .control {
  border-width: 1px;
  border-style: solid;
  cursor: pointer;
  box-sizing: border-box;
  outline: none;
  border-radius: var(--goto-radius-small);
  white-space: normal;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font: var(--goto-button-medium);
  height: 2.25rem;
  padding: var(--goto-button-padding, 0 1rem);
  min-width: var(--goto-button-min-width, 5rem);
  margin: var(--goto-button-margin);
  white-space: nowrap;
  width: 100%;
}
:host([appearance=primary]) .control ::slotted(chameleon-svg[slot=start]),
:host([appearance=secondary]) .control ::slotted(chameleon-svg[slot=start]),
:host([appearance=tertiary]) .control ::slotted(chameleon-svg[slot=start]) {
  --goto-icon-size: 1.125rem;
  margin: 0 7px 0px -5px;
}
:host([appearance=primary]) .control ::slotted(chameleon-svg[slot=end]),
:host([appearance=secondary]) .control ::slotted(chameleon-svg[slot=end]),
:host([appearance=tertiary]) .control ::slotted(chameleon-svg[slot=end]) {
  --goto-icon-size: 1.125rem;
  margin: 0 -5px 0px 7px;
}
:host([appearance=primary]) .control :hover,
:host([appearance=secondary]) .control :hover,
:host([appearance=tertiary]) .control :hover {
  text-decoration: none;
}

:host([appearance=primary]) .control {
  background-color: var(--goto-interactive-color-primary-default);
  border-color: var(--goto-interactive-color-primary-default);
  color: var(--goto-type-color-inverted);
  --goto-icon-color: var(--goto-icon-color-inverted);
}
:host([appearance=primary]) .control:hover {
  background-color: var(--goto-interactive-color-primary-hover);
  border-color: var(--goto-interactive-color-primary-hover);
}
:host([appearance=primary]) .control:active {
  background-color: var(--goto-interactive-color-primary-pressed);
  border-color: var(--goto-interactive-color-primary-pressed);
  box-shadow: none;
}
:host([appearance=primary]) .control:focus-visible {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
}
:host([appearance=primary]) .control:-moz-focusring {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
}
:host([appearance=primary]) .control:disabled {
  background-color: var(--goto-interactive-color-disabled);
  border-color: transparent;
  color: var(--goto-type-color-disabled);
  cursor: default;
  --goto-icon-color: var(--goto-icon-color-disabled);
}
:host([appearance=primary]) .control .start,
:host([appearance=primary]) .control .end {
  display: flex;
  align-items: center;
}

:host([appearance=primary][disabled]) .control,
:host([appearance=secondary][disabled]) .control,
:host([appearance=tertiary][disabled]) .control,
:host([appearance=link][disabled]) .control {
  pointer-events: none;
}
:host([appearance=primary][disabled]) .control:focus-visible,
:host([appearance=secondary][disabled]) .control:focus-visible,
:host([appearance=tertiary][disabled]) .control:focus-visible,
:host([appearance=link][disabled]) .control:focus-visible {
  box-shadow: none;
  border: none;
}

:host([appearance=primary][disabled]) .control {
  background-color: var(--goto-interactive-color-disabled);
  border-color: transparent;
  color: var(--goto-type-color-disabled);
  cursor: default;
  --goto-icon-color: var(--goto-icon-color-disabled);
}

:host([appearance=secondary]) .control {
  color: var(--goto-type-color-brand-default);
  --goto-icon-color: var(--goto-icon-color-brand-default);
  border-color: var(--goto-border-color-default);
  background-color: var(--goto-interactive-color-secondary-default);
}
:host([appearance=secondary]) .control:hover {
  background-color: var(--goto-interactive-color-secondary-hover);
}
:host([appearance=secondary]) .control:active {
  background-color: var(--goto-interactive-color-secondary-pressed);
  box-shadow: none;
}
:host([appearance=secondary]) .control:focus-visible {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
}
:host([appearance=secondary]) .control:-moz-focusring {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
}
:host([appearance=secondary]) .control:disabled {
  background-color: var(--goto-interactive-color-secondary-default);
  border-color: var(--goto-border-color-default);
  color: var(--goto-type-color-disabled);
  --goto-icon-color: var(--goto-icon-color-disabled);
}
:host([appearance=secondary]) .control .start,
:host([appearance=secondary]) .control .end {
  display: flex;
  align-items: center;
}

:host([appearance=secondary][disabled]) .control {
  background-color: var(--goto-interactive-color-secondary-default);
  border-color: var(--goto-border-color-default);
  color: var(--goto-type-color-disabled);
  --goto-icon-color: var(--goto-icon-color-disabled);
}

:host([appearance=tertiary]) .control {
  border: none;
  color: var(--goto-type-color-default);
  --goto-icon-color: var(--goto-icon-color-default);
  background-color: var(--goto-interactive-color-secondary-default);
}
:host([appearance=tertiary]) .control:hover {
  background-color: var(--goto-interactive-color-secondary-hover);
}
:host([appearance=tertiary]) .control:active {
  background-color: var(--goto-interactive-color-secondary-pressed);
}
:host([appearance=tertiary]) .control:focus-visible {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
}
:host([appearance=tertiary]) .control:-moz-focusring {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
}
:host([appearance=tertiary]) .control:disabled {
  background-color: var(--goto-interactive-color-secondary-default);
  border-color: var(--goto-border-color-default);
  color: var(--goto-type-color-disabled);
  --goto-icon-color: var(--goto-icon-color-disabled);
}
:host([appearance=tertiary]) .control .start,
:host([appearance=tertiary]) .control .end {
  display: flex;
  align-items: center;
}

:host([appearance=tertiary][disabled]) .control {
  background-color: var(--goto-interactive-color-secondary-default);
  border-color: var(--goto-border-color-default);
  color: var(--goto-type-color-disabled);
  --goto-icon-color: var(--goto-icon-color-disabled);
}

:host([appearance=link][disabled]) .control {
  color: var(--goto-type-color-disabled);
}

:host([size=small]) .control {
  font: var(--goto-button-small);
  height: 1.875rem;
  padding: var(--goto-button-padding, 0 0.875rem);
}
:host([size=small]) .control ::slotted(chameleon-svg[slot=start]) {
  --goto-icon-size: 1rem;
  margin: 0 6px 0px -4px;
}
:host([size=small]) .control ::slotted(chameleon-svg[slot=end]) {
  --goto-icon-size: 1rem;
  margin: 0 -4px 0px 6px;
}

:host([size=large]) .control {
  font: var(--goto-button-large);
  height: 2.625rem;
  padding: var(--goto-button-padding, 0 1.25rem);
}
:host([size=large]) .control ::slotted(chameleon-svg[slot=start]) {
  --goto-icon-size: 1.25rem;
  margin: 0 10px -2px -5px;
}
:host([size=large]) .control ::slotted(chameleon-svg[slot=end]) {
  --goto-icon-size: 1.25rem;
  margin: 0 -5px -2px 10px;
}

:host([size=xlarge]) .control {
  font: var(--goto-button-xlarge);
  height: 3rem;
  padding: var(--goto-button-padding, 0 1.5rem);
}
:host([size=xlarge]) .control ::slotted(chameleon-svg[slot=start]) {
  --goto-icon-size: 1.375rem;
  margin: 0 12px -2px -5px;
}
:host([size=xlarge]) .control ::slotted(chameleon-svg[slot=end]) {
  --goto-icon-size: 1.375rem;
  margin: 0 -5px -2px 12px;
}`; export default styles;